import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import jp from './i18n/jp';

i18next.addResourceBundle('en', 'initializationPage', en);
i18next.addResourceBundle('jp', 'initializationPage', jp);

const InitializationConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: [
				'/initialization/:id',
				'/initialization/0',
				'/initialization/1',
				'/initialization/2',
				'/initialization/3'
			],
			component: React.lazy(() => import('./Initialization'))
		}
	]
};

export default InitializationConfig;
